import script from "./virus-detection.vue?vue&type=script&setup=true&lang=ts"
export * from "./virus-detection.vue?vue&type=script&setup=true&lang=ts"

import "./virus-detection.vue?vue&type=style&index=0&id=11a266df&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11a266df"]])

export default __exports__